import { useEffect, useState } from 'react';

const TICK_MS = 1000;

const secondsBetween = (until: number | null, now: number): number =>
  until === null ? 0 : Math.max(0, Math.ceil((until - now) / 1000));

/** Whole seconds left until `until` (epoch ms), re-rendering every second; 0 when there is no deadline. */
export function useCountdown(until: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (until === null) return;
    setNow(Date.now());
    const handle = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(handle);
  }, [until]);

  return secondsBetween(until, now);
}
